import React from "react";
import { StaticImage  } from "gatsby-plugin-image";

const Logo = () => {
  return <StaticImage
    src="../assets/images/logo.png"
    alt="Hakula Style"
    placeholder="blurred"
    layout="constrained"
    width={400}
    height={100}/>;
};

export default Logo;
